import React, { FC, memo, useState } from 'react';

import { InfoCircleOutlined } from '@ant-design/icons';
import { Popover } from 'antd';
import { useTranslation } from 'react-i18next';

import { BRANDING } from '@/config/branding';
import { PUBLIC_ASSETS } from '@/consts';
import DownloadProtectionPopup from './DownloadProtectionPopup';
import nameSpace from '../i18nNameSpace';
import styles from './ViewerHint.module.scss';
import './DownloadProtectionPopover.scss';

interface ViewerHintProps {
    allFilesCount: number;
    filename: string;
    hint: string | null;
    hasPasswordProtection: boolean;
}

const ViewerHint: FC<ViewerHintProps> = ({ allFilesCount, filename, hint, hasPasswordProtection }) => {
    const { t } = useTranslation();
    const [isPopoverOpen, setIsPopoverOpen] = useState(false);

    const handleOpenChange = (open: boolean): void => {
        setIsPopoverOpen(open);
    };

    return (
        <div className={styles['viewer-hint']} data-testid="recipientPage_openFileText">
            {BRANDING !== 'unbranded' && (
                <img
                    alt=""
                    className={styles['spx-dark-icon']}
                    src={`${PUBLIC_ASSETS}/company_logo/specterx-icon.png`}
                />
            )}
            <span className={styles['viewer-hint-text']}>
                {t(`${nameSpace}.viewFilesSecurely`, { count: allFilesCount })}
            </span>
            {hasPasswordProtection && (
                <Popover
                    trigger="click"
                    overlayClassName="download-protection-popover"
                    onOpenChange={handleOpenChange}
                    open={isPopoverOpen}
                    content={(
                        <DownloadProtectionPopup
                            filename={filename}
                            hint={hint}
                            onClose={() => setIsPopoverOpen(false)}
                        />
                    )}
                >
                    <span className={styles['info-icon-wrapper']}>
                        <InfoCircleOutlined className={styles['info-icon']} />
                    </span>
                </Popover>
            )}
        </div>
    );
};

export default memo(ViewerHint);
